<template>
  <div>
    <apexchart
		:type="type"
		:height="height"
		:width="width"
		:options="chartOptions"
		:series="series"
		:ischart="ischart"
		:categorie="categories"
		:loading="loading"
    ></apexchart>
  </div>
</template>

<script>

export default {
	props: {
		type: { type: String },
		options: {
			type: Object
		},
		series: {},
		width: {},
		height: {},
		ischart: {
			type: String
		},
		categories: {
			type: Array
		},
		loading: {
			type: Boolean
		}
		// series: {
		// 	type:Array
		// }
	},
	computed: {
		chartOptions () {
			return {
				chart: {
					width: this.width,
					height: this.height,
					type: 'bar'
				},
				plotOptions: {
					bar: {
						borderRadius: 5,
						dataLabels: {
							position: 'top'
						}
					}
				},
				dataLabels: {
					enabled: this.type === 'bar' ? true : false,
					formatter: function (val) {
						return val
					},
					offsetY: 10,
					style: {
						fontSize: '12px'
						// colors: ['#fff']
					}
				},
				yaxis: {
					labels: {
						show: true
					}
				},
				markers: {
					size: 5
				},
				xaxis: {
					type: 'category',
					categories: this.categories
				},
				tooltip: {
					enabled: false
				},
				grid: {
					show: true
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				}
			}
		}
	}
}
</script>
